export const profile = {
    profileFavoritesIconTitle: 'Favorites',
    profileEditIconTitle: 'Edit',
    profileShareIconTitle: 'Share',
    profileAdditionalSectionTitle: 'Additional info',
    profileFavoritesCurtainTitle: 'Favorites',
    profileFavoriteActionTitle: 'Favorite',
    profileFavoritedActionTitle: 'Favorited',
    profileMessageAction: 'Message',
    profileCurtainAdd: 'Add',
    profileReportUser: 'Flag user',
    profileReportTitle: 'Flag',
    profileReportSuccess: 'Content reported',
    profileReset: 'Reset',
    profileApply: 'Apply',
    profileCustomInvalidEmail: 'is not a valid email address',
    profileMaxContentSizeError: 'You have exceeded max content size!',
    profileMaxAvatarSizeError: 'Your avatar size is too large!',
    profileFavoritesCurtainSearchInputText: 'Search',
    profileTapShareCurtainOptionTitle: 'Copy link',
    profileTapShareLinkCopiedAlertTitle: 'Link copied!',
    profileQrShareCurtainTitle: 'Share Profile',
    profileQrShareCurtainShareButtonTitle: 'Share',
    profileQrShareCurtainCopyButtonTitle: 'Copy link',
    profileQrShareCurtainCopiedAlertTitle: 'Link copied!',
    profileQrTapShareProfileCurtainTitle: 'Share Your Profile',
    profileEditTitle: 'Edit',
    profileEditPersonalSectionTitle: 'Personal details',
    profileEditContactsSectionTitle: 'Contacts',
    profileEditSocialSectionTitle: 'Social',
    profileEditAddSocialButtonTitle: 'Add Social Media',
    profileEditAdditionalSectionTitle: 'Additional info',
    profileEditSaveButtonTitle: 'Save',
    profileEditSavedAlertTitle: 'Profile saved!',
    profileEditEmptyRequiredInputTitle: 'Value cannot be blank',
    profileEditEmptyRequiredEmailInputTitle: 'Public Email is not a valid email address',
    profileEditEmptyRequiredErrorTitle: 'Something went wrong!',
    profileEditSocialsHint: 'Please insert URL to your social profile',
    preferences: 'Preferences',
    interestedIn: 'Interested in',
    expertIn: 'I\'m an Expert in',
    myPitch: 'My Pitch',
    qrBadge: 'QR Badge',
    touchpoints: 'Touchpoints',
    lookingFor: 'I\'m looking for',
    topicsToDiscuss: 'Topics to discuss',
    createNew: 'Create new',
    viewTopic: 'View topic',
    join: 'Join',
    hobbyInterests: 'Hobby & Interests',
    myNetwork: 'My Network',
    seeAll: 'See all',
    checkThemOut: 'Check them out!',
    activities: 'Activities',
    oneOnOne: '1:1 Meet',
    Leaderboard: 'Leaderboard',
    learnNetworking: 'Learn more about Networking Hub',
    networkingGroup: 'Networking Group',
    networkingLevel: 'Networking Level',
    message: 'Message',
    scheduleOneOnOne: 'Schedule 1:1',
    addNote: 'Add note',
    notes: 'Notes',
    enterNote: 'Enter a note',
    shareUserProfile: 'Share User Profile',
    flagUser: 'Flag User'
}